"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Range = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var range_style_1 = require("./range-style");
var range_type_1 = require("./range-type");
function Range(props) {
    var _a = props.helpPosition, helpPosition = _a === void 0 ? range_type_1.RangeHelpPosition.INSIDE : _a, restProps = __rest(props, ["helpPosition"]);
    return (0, jsx_runtime_1.jsx)(range_style_1.StyledRange, __assign({}, restProps, { trackColor: "#2E9E62", helpPosition: helpPosition }));
}
exports.Range = Range;
